<div class="border-steel-20 mat-elevation-z3 error-card m-8 max-w-2xl rounded-md p-4"
     *transloco="let t; read: 'fallbackPages.404'">
  <rma-star-rating class="mb-2" [allowZeroStars]="true" [overallStars]="0" />
  <h1 class="text-2xl font-bold">{{ t('title') }}</h1>
  <p class="text-steel-70 mb-4">{{ t('subtitle') }}</p>

  @if (showBackButton$ | async) {
    <a class="home-button" routerLink="/" mat-flat-button color="primary">
      {{ t('action.home') }}
    </a>
  }
</div>
